// Captures the current viewport as a PNG data URL using html2canvas.
// Returns null on failure so callers can fall back gracefully.

export async function captureScreenshot(): Promise<string | null> {
  if (typeof window === "undefined" || typeof document === "undefined") return null;
  try {
    const { default: html2canvas } = await import("html2canvas");
    const canvas = await html2canvas(document.body, {
      logging: false,
      useCORS: true,
      backgroundColor: null,
      scale: Math.min(window.devicePixelRatio || 1, 1.5),
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight,
    });
    // Compress: shrink to max 1280px wide
    const maxW = 1280;
    if (canvas.width > maxW) {
      const scaled = document.createElement("canvas");
      const ratio = maxW / canvas.width;
      scaled.width = maxW;
      scaled.height = Math.round(canvas.height * ratio);
      const ctx = scaled.getContext("2d");
      if (ctx) {
        ctx.drawImage(canvas, 0, 0, scaled.width, scaled.height);
        return scaled.toDataURL("image/png");
      }
    }
    return canvas.toDataURL("image/png");
  } catch (e) {
    console.warn("screenshot capture failed", e);
    return null;
  }
}
